import React from 'react';
import BentoGrid from '@ajat/design-system/ContentBlocks/BentoGrid';
import { ComponentPage, DemoCard } from '../../shared';
import { PATCH_UNIVERSE } from './contentDemoData';

export const meta = {
  component: BentoGrid,
  title: 'Bento Grid',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/BentoGrid',
  figmaNode: '2222:152661',
  description:
    '"Patch Universe" (OVER-LL): title block with filter tabs, a dense mosaic of patch cards — small, wide (2 columns) and one 2×2 photo feature card — and a CTA. 6 columns × 248px rows on desktop, 2 columns × 164px rows on mobile (2645:13450). Cards reuse the configurator card surface. The first tab shows everything; the others filter by item tags, untagged cards (the feature) always stay.',
  props: [
    ['caption', 'string', "''", 'Eyebrow above the title'],
    ['title', 'string', "''", 'Section title (typo-h2-editorial)'],
    ['tabs', 'array', '[]', '[{ id, label }] — the first one means "all"'],
    ['defaultTab', 'string', 'first tab', 'Initial tab (uncontrolled)'],
    ['activeTab', 'string', '—', 'Active tab (controlled)'],
    ['onTabChange', 'func', '—', 'Called with the clicked tab id'],
    ['items', 'array', '[]', "[{ id, image, alt, size: 'small' | 'wide' | 'feature', tags, title, linkLabel, href, onClick }] in desktop reading order"],
    ['ctaLabel', 'string', "''", 'CTA under the grid (Button secondary / outline)'],
    ['ctaVariant', 'string', "'outline'", 'CTA Button variant'],
    ['ctaHref', 'string', '—', 'CTA link target — renders it as a real link'],
    ['ctaOnClick', 'func', '—', 'CTA handler'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'On the OVER/LL landing',
      code: `<BentoGrid
  caption="Anpassning"
  title="Patch Universe"
  tabs={[{ id: 'all', label: 'Alla' }, { id: 'graphic', label: 'Graphic' }, { id: 'text', label: 'Text' }]}
  items={[
    { id: 'after-ski', image: afterSki, alt: 'After Ski', tags: ['graphic'] },
    { id: 'iron', size: 'feature', image: iron, title: 'Fäst ditt märke med ett strykjärn', linkLabel: 'Discover more', onClick: openGuide },
    { id: 'spicy', size: 'wide', image: spicy, alt: 'Spicy Girls Club', tags: ['text'] },
  ]}
  ctaLabel="Se alla patches"
  ctaOnClick={() => navigate('/overalls/configurator')}
/>`,
    },
  ],
};

export default function BentoGridPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Patch Universe" hint="Figma 2222:152661 · tabs filter by item tags" flush>
        <BentoGrid {...PATCH_UNIVERSE} />
      </DemoCard>
    </ComponentPage>
  );
}
